var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9796 5C13.3127 5 11.1508 7.16195 11.1508 9.82886C11.1508 12.4958 13.3127 14.6577 15.9796 14.6577C18.6465 14.6577 20.8085 12.4958 20.8085 9.82886C20.8085 7.16195 18.6465 5 15.9796 5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8289 17.2331C8.16195 17.2331 6 19.3951 6 22.062V23.5921C6 24.562 6.70293 25.389 7.66019 25.5453C13.17 26.4449 18.7893 26.4449 24.2991 25.5453C25.2563 25.389 25.9593 24.562 25.9593 23.5921V22.062C25.9593 19.3951 23.7973 17.2331 21.1304 17.2331H20.6915C20.4539 17.2331 20.2178 17.2707 19.992 17.3444L18.8775 17.7083C16.9945 18.3232 14.9648 18.3232 13.0818 17.7083L11.9673 17.3444C11.7414 17.2707 11.5054 17.2331 11.2678 17.2331H10.8289Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFill);
export default __webpack_public_path__ + "static/media/icon_user_fill.156a52076355ffa15ec3df9c20633310.svg";
export { ForwardRef as ReactComponent };